import {
  WechatContact,
  WechatMessageType,
  WechatRoom,
  SendingStatus,
  WS_RESPONSE_MESSAGE_TYPE,
  WechatConversationDataType,
  ChannelTypeEnum,
  WechatFriendApplyData,
} from "../..";
import {
  WechatAcceptFriendData,
  WechatConversationStatusChangeData,
  WechatErrorData,
  WechatFriendDeleteNoticeData,
  WechatLoginSuccessData,
  WechatNewFriendApplyData,
  WechatReceiveLoginQRCodeData,
  WechatRecovateMessageData,
  WechatRemoveCustomerToRoomData,
  WechatScanningQRCodeData,
  WechatUnreadNumUpdateData,
  WechatVerifyVerificationCodeData,
} from "./ws-types";
import chatSdkHooks from "../../hooks";
import { WSResponseData } from "../../request/ws";

const waitingWorks = [] as WSResponseData[];

function handlePushWaitWorks(data: WSResponseData) {
  waitingWorks.push(data);
}
export function wsHandler(data: WSResponseData) {
  if (data.type) {
    handlePushWaitWorks(data);
  }
}

// @ts-ignore
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

function handlePopWaitWorks() {
  window.requestIdleCallback(
    () => {
      const work = waitingWorks.shift();
      if (work) {
        const { data, type, user_id, client_id, ip, error } = work;
        switch (type) {
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_LOGIN_QRCODE:
            handleReceiveLoginQRCode(
              data as WechatReceiveLoginQRCodeData,
              client_id,
              ip
            );
            break;
          case WS_RESPONSE_MESSAGE_TYPE.SCANING:
            handleScanningLoginQRCode(data as WechatScanningQRCodeData, error);
            break;
          case WS_RESPONSE_MESSAGE_TYPE.VERIFY_VERIFICATION_CODE: {
            handleVerifyVerificationCode(
              data as WechatVerifyVerificationCodeData
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_SUCCESS:
            handleLoginSuccess(data as WechatLoginSuccessData);
            break;
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_OUT:
          case WS_RESPONSE_MESSAGE_TYPE.CLIENT_CLOSE: {
            handleLogout(user_id, data?.quit_reason);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.GET_ROOM_DETAIL: {
            handleGetRoomDetail(data as WechatRoom, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_MESSAGE:
          case WS_RESPONSE_MESSAGE_TYPE.OTHER_TERMINAL_RECEIVE_MESSAGE:
          case WS_RESPONSE_MESSAGE_TYPE.REVOCATION_MESSAGE_NOTICE:
          case WS_RESPONSE_MESSAGE_TYPE.FILE_DOWNLOAD_SUCCESS_NOTICE:
          case WS_RESPONSE_MESSAGE_TYPE.VOICE_TO_TEXT_NOTICE: {
            handleReceiveMessage(data as WechatMessageType, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.REVOCATION_MESSAGE_SUCCESS_NOTICE: {
            handleRevocateMessage(data as WechatRecovateMessageData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_CHANGE: {
            handleConversationChange(data as WechatConversationDataType);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_STATUS_CHANGE: {
            handleConversationStatusChange(
              data as WechatConversationStatusChangeData
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.GET_CONTACT_DETAIL: {
            handleGetContactDetail(data as WechatContact, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.ACCEPT_FRIEND: {
            handleAcceptFriend(data as WechatAcceptFriendData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.REMOVE_CUSTOMER_TO_CREATE_ROOM:
          case WS_RESPONSE_MESSAGE_TYPE.REMOVE_CUSTOMER_TO_CREATED_ROOM: {
            handleRemoveCustomerToRoom(data as WechatRemoveCustomerToRoomData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.UNREAD_NUM_UPDATE: {
            handleUnreadNumUpdate(data as WechatUnreadNumUpdateData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_NEW_FRIEND_APPLY: {
            handleReceiveNewFriendApply(
              data as WechatNewFriendApplyData,
              user_id
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.FRIEND_DELETE_NOTICE: {
            handleFriendDeleteNotice(
              data as WechatFriendDeleteNoticeData,
              user_id
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.ERROR: {
            handleError(data as WechatErrorData);
            break;
          }
        }
      }
      handlePopWaitWorks();
    },
    { timeout: 100 }
  );
}
handlePopWaitWorks();

/** 接收登录二维码信息 **/
function handleReceiveLoginQRCode(
  data: WechatReceiveLoginQRCodeData,
  client_id: number,
  ip?: string
) {
  chatSdkHooks.common.receiveLoginQRCodeHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    data: {
      ...data,
      ip,
      client_id,
      url: `/api/damselfish-chat-bot/command/qrCode/WECHAT/${data?.login_qrcode_key}`,
    },
  });
}

/** 监听扫码，此时接口会返回扫码过程中的用户信息 */
function handleScanningLoginQRCode(
  data: WechatScanningQRCodeData,
  error?: number
) {
  console.log("正在扫码");
  chatSdkHooks.common.scaningHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    data: { ...data, error },
  });
}

/** 验证验证码返回的结果 */
function handleVerifyVerificationCode(data: WechatVerifyVerificationCodeData) {
  chatSdkHooks.common.verifyVerificationCodeHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    data,
  });
}

/** 登录成功之后将用户信息存放到db */
function handleLoginSuccess(data: WechatLoginSuccessData) {
  chatSdkHooks.common.loginSuccessHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    user_id: data?.user_id,
  });
}

function handleLogout(user_id: string, quit_reason: string = "") {
  chatSdkHooks.common.logoutHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    user_id,
    quit_reason,
  });
}

/**
 * 处理接收到的最新群信息
 */
function handleGetRoomDetail(data: WechatRoom, from_user_id: string) {
  chatSdkHooks.wechat.getRoomDetailHook.emit({
    ...data,
    from_user_id,
    id: `${from_user_id}_${data.room_id}`,
  });
}

/**
 * 处理接收到的最新联系人信息
 */
function handleGetContactDetail(data: WechatContact, from_user_id: string) {
  chatSdkHooks.wechat.getContactDetailHook.emit({
    ...data,
    from_user_id,
    id: `${from_user_id}_${data.user_id}`,
  });
}

/** 监听接收到的消息 */
function handleReceiveMessage(data: WechatMessageType, from_user_id: string) {
  chatSdkHooks.wechat.receiveMessageHook.emit({
    ...data,
    from_user_id,
    sending_status: SendingStatus.SUCCESS,
  });
}

/** 撤回消息 */
function handleRevocateMessage(data: WechatRecovateMessageData) {
  chatSdkHooks.wechat.revocateMessageHook.emit(data);
}

/** 处理会话变更 */
function handleConversationChange(data: WechatConversationDataType) {
  chatSdkHooks.wechat.conversationChangeHook.emit(data);
}

/** 处理会话状态变更 */
function handleConversationStatusChange(
  data: WechatConversationStatusChangeData
) {
  // 未读数变化不在这里做处理，在conversationChangeHook已经有通知了
  const effectiveData = {
    data: data?.data
      ?.filter(
        (item: any) => item?.unread === undefined || item?.unread === null
      )
      ?.map((item: any) => {
        Object.entries(item).forEach(([key, value]) => {
          if (value === undefined || value === null) {
            delete item[key as keyof typeof item];
          }
        });
        return item;
      }),
    request_key: data?.request_key,
  };
  chatSdkHooks.wechat.conversationStatusChangeHook.emit(effectiveData);
}

/** 处理好友申请 */
function handleAcceptFriend(data: WechatAcceptFriendData) {
  chatSdkHooks.wechat.acceptFriendHook.emit(data);
}

function handleRemoveCustomerToRoom(data: WechatRemoveCustomerToRoomData) {
  chatSdkHooks.wechat.removeCustomerToRoomHook.emit(data);
}

function handleUnreadNumUpdate(data: WechatUnreadNumUpdateData) {
  chatSdkHooks.wechat.unreadNumUpdateHook.emit(data);
}

function handleError(data: WechatErrorData) {
  chatSdkHooks.common.wsErrorHook.emit({
    channelType: ChannelTypeEnum.Wechat,
    message: data.error_msg,
  });
}

function handleReceiveNewFriendApply(
  data: WechatNewFriendApplyData,
  from_user_id: string
) {
  const newData = {
    id: `${from_user_id}_${data?.user_id}`,
    avatar: data?.avatar,
    from_user_id,
    is_wecom: data?.is_wecom,
    name: data?.name,
    user_id: data?.user_id,
    apply_time: data?.apply_time,
    apply_source: data?.apply_source,
    apply_reason: data?.apply_reason,
  } as WechatFriendApplyData;
  chatSdkHooks.wechat.receiveNewFriendApplyHook.emit(newData);
}

function handleFriendDeleteNotice(
  data: WechatFriendDeleteNoticeData,
  from_user_id: string
) {
  chatSdkHooks.wechat.friendDeleteHook.emit(`${from_user_id}_${data?.user_id}`);
}
